var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageStatusFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#CE172F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0994 14.0001L19.7719 9.32729C20.076 9.02334 20.076 8.53191 19.7719 8.22796C19.468 7.92401 18.9766 7.92401 18.6726 8.22796L13.9999 12.9008L9.32737 8.22796C9.02329 7.92401 8.532 7.92401 8.22806 8.22796C7.92398 8.53191 7.92398 9.02334 8.22806 9.32729L12.9006 14.0001L8.22806 18.6729C7.92398 18.9768 7.92398 19.4683 8.22806 19.7722C8.37953 19.9238 8.5787 20 8.77772 20C8.97674 20 9.17576 19.9238 9.32737 19.7722L13.9999 15.0994L18.6726 19.7722C18.8242 19.9238 19.0233 20 19.2223 20C19.4213 20 19.6203 19.9238 19.7719 19.7722C20.076 19.4683 20.076 18.9768 19.7719 18.6729L15.0994 14.0001Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageStatusFail);
export default __webpack_public_path__ + "static/media/page-status-fail.3553e5e86c6419499617ea6ca8a5487d.svg";
export { ForwardRef as ReactComponent };